import { formatExpedientLabel } from "../../utils/form-interns.utils";
import type { RenderProps } from "./types";

export default function expedientRenderer({ targetField, value }: RenderProps) {
  const label = formatExpedientLabel(
    targetField?.unique_code,
    targetField?.name,
    value,
  );
  return label ? (
    <p className="wrap-break-word whitespace-pre-wrap text-size-body">
      {label}
    </p>
  ) : (
    <span className="text-on-disabled-quiet">Vacío</span>
  );
}
